import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';

import EstimateReducer, { INITIAL_STATE, INIT } from './reducer';
import * as actions from './actions';

const EstimateContext = createContext({
    DISPATCH: null,
    state: {},
    actions: {},
});

export const EstimateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(EstimateReducer, { ...INITIAL_STATE }, INIT);

    const value = {
        state,
        // @ts-ignore
        DISPATCH: (data) => { dispatch(data); },
        actions: {
            getEstimate: actions.getEstimate,
            loadEstimate: actions.loadEstimate(dispatch),
        },
    };

    return (
        <EstimateContext.Provider value={value}> { children } </EstimateContext.Provider>
    );
};

EstimateProvider.propTypes = {
    children: PropTypes.node,
};

export const useEstimate = () => useContext(EstimateContext);
